export type GetUserAddressDetailQuerySuccessResponseKeys =
  | 'user_id'
  | 'state_name'
  | 'district_name'
  | 'address_type'
  | 'city_name'
  | 'pin_code';

const allUserAddressDetailQuerySuccessKeys: GetUserAddressDetailQuerySuccessResponseKeys[] =
  [
    'user_id',
    'state_name',
    'district_name',
    'address_type',
    'city_name',
    'pin_code'
  ];

const getUserAddressDetailQuery = (
  successKeys: GetUserAddressDetailQuerySuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length
    ? successKeys
    : allUserAddressDetailQuerySuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserAddressDetail {
      user_address_details {
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_address_details{
      ${successFields}
      ${failureFields}
    }
  `;
};

export { getUserAddressDetailQuery };
